<template>
    <b-modal size="md" centered id="send-quote-confirmation" @close="closeModal">
        <!-- close-btn -->
        <b-button variant="close-btn" @click.prevent="closeModal">
            <i class="fas fa-times"></i>
        </b-button>

        <!-- header -->
        <div class="text-center">
            <h5><strong>Confirmation</strong> </h5>
        </div>

        <!-- body -->
        <div class="text-center">
            <p>Send group quote details via email ?</p>
        </div>

        <div class="confirmation-button-group justify-content-center">
            <b-button @click="closeModal" class="cancel">Cancel</b-button>
            <b-button @click="sendEmail" variant="primary" class="confirm-btn">Confirm</b-button>
        </div>
    </b-modal>
</template>

<script>
import Api from '../../../resource/Api';

export default {
    name: "SendQuoteConfirmation",
    props: {
        groupCensusId: {
            type: [String, Number],
            required: true,
        },
    },
    methods: {
        closeModal() {
            this.$bvModal.hide("send-quote-confirmation")
        },

        //update vuex store and group quotes stored in the store
        updateStore() {
            this.$store.dispatch('fetchGroupQuotes');
            this.$store.commit('setActiveList', 'group');
        },

        //send email when confirm button is clicked
        sendEmail() {
            let loader = this.$loading.show();
            const url = `v2/quote/send-groupquote-personalized`
            const payload = {"group_census_id": this.groupCensusId}
            Api.post(url, payload).then((response) => {
                const status = response.status;
                if (status == 200) {
                    this.$notify(response.data.message)
                    this.updateStore();
                    this.closeModal();
                }
            }).catch((err) => {
                console.error(err)
                if(err.response.data.message=='Quote has been declined. Cannot send email.'){
                    this.$notify('Quote has been declined. Cannot send email.', 'error');
                }else{
                 this.$notify(err.message, "error");

                }
                this.closeModal();
            }).finally(() => {
                loader.hide();
            })
        },
    }
}
</script>

<style scoped>
.confirmation-button-group{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 1.25rem;
}
.confirmation-button-group  button{
    padding: .25rem 1.5rem;
}
.confirmation-button-group .confirm-btn{
    background: linear-gradient(#0cf, #1597b8 49%, #0567bc) !important;
    border: none;
}
</style>